export enum ModalType {
  REMOTE_CONNECTION = "remoteConnection",
  RESTART_SHELL = "restartShell",
  ERROR = "error",
  SUCCESS = "success",
}
